import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import serverClient from '../api/ServerClient';
import { DeleteToken, GetToken } from '../auth/Auth';

function useLogout(e) {
    e?.preventDefault();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleLogout = async () => {
        setLoading(true);
        try {
            await serverClient.post(`/api/auth/logout`, {
                headers: {
                    Authorization: `Bearer ${GetToken()}`,
                },
            });
            DeleteToken();
        } catch (err) {
            DeleteToken();
        } finally {
            // Clean up offcanvas classes
            const offCanvasBackdrop = document.querySelector('.offcanvas-backdrop');
            if (offCanvasBackdrop) {
                offCanvasBackdrop.remove();
            }

            document.body.classList.remove('offcanvas-open');

            setLoading(false);
            navigate('/login');
        }
    };

    return { handleLogout, loading };
}

export default useLogout;
